// Part 1
import { createSlice } from "@reduxjs/toolkit"

// Part 2
export interface CfmServiceAddressInitialState {
  activeAddressIndex: string;
}

const initialState: CfmServiceAddressInitialState = {
  activeAddressIndex: '0'
}

// Part 3
export const cfmServiceAddressSlice = createSlice({
  name: 'cfmServiceAddress',
  initialState,
  reducers: {
    setActiveServiceAddressIndex: (state, action) => {
      state.activeAddressIndex = action.payload
    },
    setActiveServiceAddressId: (state, action) => {
      state.activeAddressIndex = action.payload
    },
  }
})

// Part 4
export const { setActiveServiceAddressIndex } = cfmServiceAddressSlice.actions
export default cfmServiceAddressSlice.reducer
